export async function QuizSubmit({ formData, lessonUid, courseUid }) {
  try {
    const url = `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/courses/${courseUid}/lessons/${lessonUid}`;

    const response = await fetch(url, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        quizAnswers: formData,
      }),
    });
    if (response.ok || response.status === 200 || response.status === 201) {
      const data = await response.json();

      const result = {
        ...data.quizResult,
        totalAttempts: data.progress.assessment.totalAttempts,
      };
      return result;
    } else {
      console.error("Assessment submission failed");
    }
  } catch (error) {
    console.error("Error submitting assessment:", error);
  }
}

export function CircularProgress({ percentage, passing_percentage }) {
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className="progress-circle">
      <svg
        width="120"
        height="120"
        viewBox="0 0 120 120"
      >
        <circle
          className="progress-circle-bg"
          cx="60"
          cy="60"
          r={radius}
        />
        <circle
          style={{
            stroke: `${percentage >= (passing_percentage || 0) ? "#007A52" : "#A31C00"}`,
          }}
          className="progress-circle-value"
          cx="60"
          cy="60"
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform="rotate(-90 60 60)"
        />
      </svg>
      <div className="progress-circle-text">{percentage}%</div>
    </div>
  );
}

export async function AssessmentSubmit({ formData, LearningPathUid }) {
  try {
    // Check test type and construct the URL accordingly
    const url = `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/learning-paths/${LearningPathUid}`;

    // Check test type
    const response = await fetch(url, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        assessmentAnswers: formData,
      }),
    });
    if (response.ok || response.status === 200 || response.status === 201) {
      const data = await response.json();

      const result = await data.assessmentResult;
      return {
        ...result,
        attemptLog: data.progress.assessment.attemptLog,
        totalAttempts: data.progress.assessment.totalAttempts,
        badgeData: data?.userBadgeData,
      };
    } else {
      console.error("Assessment submission failed");
      throw new Error("Assessment submission failed");
    }
  } catch (error) {
    throw error;
  }
}
